export const imagesCarousel = () => {


    /*
    * Slider.
    * */
    $(function() {
        $(document).ready(function(){

            $('.js-c-box-image').slick({
                dots: false,
                infinite: true,
                speed: 600,

            });

        });
    });
};
